import axios from "axios";
import { useMemo } from "react";
import type { ImmutableObject } from "@/lib/immutable";
import { setStorefrontSdkBasePath } from "@/storefrontsdk";
import { createStore, type Store, useStore } from "./store";

export type AppConfig = {
	BaseUrl: string;
	StorefrontAppUrl: string;
	CompanyName: string;
	CompanyLogoUrl: string;
	ClientCode: string;
	AzureAD: AzureAD;
};

export type AzureAD = {
	Instance: string;
	ClientId: string;
	TenantId: string;
};

export class AppConfigModel {
	appConfig?: AppConfig;
	isLoading: boolean = false;
}

const appConfigStore = createStore<AppConfigModel>(new AppConfigModel());

export class AppConfigState {
	private appConfigState: Store<AppConfigModel>;

	constructor(siteConfigState: Store<AppConfigModel>) {
		this.appConfigState = siteConfigState;
	}

	get(): ImmutableObject<AppConfigModel> {
		return this.appConfigState.getState();
	}

	async loadAsync() {
		try {
			if (!this.appConfigState.getState().isLoading) {
				this.appConfigState.setState((prev) => ({ ...prev, isLoading: true }));

				//const currUrl = window.location.href.substring(0, window.location.href.length - window.location.hash.length);
				//let siteRootUrl;
				//if (currUrl.charAt(currUrl.length - 1) === '/') {
				//    siteRootUrl = currUrl.slice(0, currUrl.length - 1);
				//} else {
				//    siteRootUrl = currUrl;
				//}
				//let basename = new URL(siteRootUrl).pathname;
				//if (!basename.endsWith('/')) {
				//    basename += '/';
				//}
				//console.log({
				//    siteRootUrl: siteRootUrl,
				//    basename: basename,
				//    url: `${basename}appconfig.json`
				//});

				//const appConfigData = (await axios.get<AppConfig>(`${basename}appconfig.json`)).data;
				const appConfigData = (
					await axios.get<AppConfig>(`/storefront/appconfig.json`)
				).data;
				this.appConfigState.setState((prev) => ({
					...prev,
					appConfig: appConfigData,
				}));
				setStorefrontSdkBasePath(appConfigData.BaseUrl);

				// theme is bound to ClientCode, so it should reload
				//this.themeState.set(this.themeState.get().themeName);
			}
		} finally {
			this.appConfigState.setState((prev) => ({ ...prev, isLoading: false }));
		}
	}

	getCheckoutUrl(): string {
		let checkoutUrl = "checkout";
		const clientCode = this.appConfigState.getState().appConfig?.ClientCode;
		if (clientCode === "TELEMUNDO") {
			checkoutUrl = "quoterequest";
		}
		return checkoutUrl;
	}
}

export function useAppConfigState(): AppConfigState {
	useStore(appConfigStore);
	return useMemo(() => new AppConfigState(appConfigStore), []);
}
